(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'TikTokPixel';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("tiktok", TrackingModel);

        if (!Tracker || !Tracker.Properties.TikTokPixelId)
            return;

        var CanTrack = LhApp.Function.Tracking.canTrack();

        var _isUserSelectedProduct;
        var listToProductMap = { sessionID: '', items: [] };

        Init();

        function Init() {
            if (!CanTrack) return;

            listToProductMap = JSON.parse(localStorage.getItem('listToProductMap')) || listToProductMap;

            //include tiktok tracking script
            !function (w, d, t) {
                w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"], ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }; for (var i = 0; i < ttq.methods.length; i++)ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)ttq.setAndDefer(e, ttq.methods[n]); return e }, ttq.load = function (e, n) { var i = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {}; var o = document.createElement("script"); o.type = "text/javascript", o.async = !0, o.src = i + "?sdkid=" + e + "&lib=" + t; var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a) };

                ttq.load(Tracker.Properties.TikTokPixelId);
                ttq.page();
            }(window, document, 'ttq');

            //TRACK product details
            if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                var product = TrackingModel.ProductData[0];
                var productPrice = parseFloat(product.PriceN);

                ttq.track('ViewContent',
                    {
                        contents: [
                            {
                                content_id: product.ProductId,
                                content_name: product.Name,
                                content_category: product.Category,
                                price: productPrice,
                            }],
                        content_type: 'product',
                        value: productPrice,
                        currency: LhApp.Context.Currency.Code
                    }
                );
            }

            //TRACK checkout Angular(ready) - Push "InitiateCheckout" Event
            if (TrackingModel.IsCheckoutPage) {
                var ready = false;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        //register events once
                        if (!ready) {
                            ready = true;

                            var smScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

                            if (!smScope) return;

                            var orderProducts = []; // Push Each Item from the model to the array
                            var productsTotalValue = 0;

                            smScope.Model.Data.Products.forEach(function (product, index) {

                                var productPrice = parseFloat(product.Price);
                                productsTotalValue += productPrice * product.Quantity;

                                orderProducts.push({
                                    content_id: product.ProductId.toString(),
                                    content_name: product.Title,
                                    brand: product.ManufacturerName,
                                    quantity: product.Quantity,
                                    price: productPrice,
                                });
                            });

                            ttq.track('InitiateCheckout', {
                                contents: orderProducts,
                                content_type: 'product',
                                value: productsTotalValue,
                                currency: LhApp.Context.Currency.Code
                            });

                        }
                    });
                }
            }

            //TRACK checkout Angular(ready) - Push "AddPaymentInfo" Event
            if (TrackingModel.IsCheckoutPage) {

                if (typeof angular === 'undefined') return;

                angular.element(document).ready(function () {
                    var paymentInfoPushed = null;
                    var orderScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                    var paymentMethodName, processorCode, paymentInfo, firstLoad = true;
                    var newValues = {};
                    var oldValues = {};

                    // Add more $watch statements as needed
                    function checkPayment() {
                        var paymentMethodName = orderScope.Model.Data.PaymentMethod.Name;
                        var processorCode = orderScope.Model.Data.PaymentMethod.ProcessorId;
                        var paymentInfo = paymentMethodName + ' ' + processorCode;

                        if (paymentInfoPushed === paymentInfo) return;
                        if (!newValues.methodId || !newValues.processorId) return;

                        if (newValues.deliveryPointCode === 'onSite') {

                            //if (newValues.methodId === oldValues.methodId && newValues.processorId === oldValues.processorId) return;

                            pushAddPaymentInfo(paymentInfo);
                            paymentInfoPushed = paymentInfo;
                        } else if (newValues.deliveryPointCode === 'fromStore') {
                            var newStoreId = orderScope.Model.Data.StoreId;

                            if (!newStoreId) return;
                            if (paymentInfoPushed && newValues.methodId === oldValues.methodId && newValues.processorId === oldValues.processorId) return;

                            pushAddPaymentInfo(paymentInfo);
                            paymentInfoPushed = paymentInfo;
                        }
                    }

                    function pushAddPaymentInfo(paymentInfo) {

                        var orderProducts = []; // Push Each Item from the model to the array
                        var productsTotalValue = 0;

                        orderScope.Model.Data.Products.forEach(function (product, index) {

                            var productPrice = parseFloat(product.Price);
                            productsTotalValue += productPrice * product.Quantity;

                            orderProducts.push({
                                content_id: product.ProductId.toString(),
                                content_name: product.Title,
                                brand: product.ManufacturerName,
                                quantity: product.Quantity,
                                price: productPrice,
                            });
                        });

                        ttq.track('AddPaymentInfo', {
                            contents: orderProducts,
                            content_type: 'product',
                            payment_type: paymentInfo,
                            value: productsTotalValue,
                            currency: LhApp.Context.Currency.Code
                        });
                    }

                    // Watch individual properties and update the new and old values
                    orderScope.$watch('Model.Data.PaymentMethod.MethodId', function (newValue, oldValue) {
                        newValues.methodId = newValue;
                        oldValues.methodId = oldValue;
                        checkPayment();
                    });
                    orderScope.$watch('Model.Data.PaymentMethod.ProcessorId', function (newValue, oldValue) {
                        newValues.processorId = newValue;
                        oldValues.processorId = oldValue;
                        checkPayment();
                    });

                    // If there are other properties you need to watch, add them similarly
                    orderScope.$watch('Model.Data.DeliveryPoint.Code', function (newValue, oldValue) {
                        newValues.deliveryPointCode = newValue;
                        oldValues.deliveryPointCode = oldValue;
                        checkPayment();
                    });
                });
            }

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData) {

                if (typeof angular === 'undefined') return;

                angular.element(document).ready(function () {
                    var orderScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                    var paymentMethodId = orderScope.Model.Data.PaymentMethod.MethodId;
                    var orderProducts = [];
                    var items = TrackingModel.CartProductsData;
                    var productsTotalValue = 0;

                    if (!paymentMethodId) return;

                    for (var i = 0; i < items.length; i++) {
                        var product = items[i];
                        var productPrice = parseFloat(product.PriceN);
                        productsTotalValue += productPrice * product.Quantity;

                        orderProducts.push({
                            content_id: product.ProductId,
                            content_name: product.Name,
                            quantity: product.Quantity,
                            price: productPrice,
                        });
                    }

                    if (paymentMethodId == 2 || paymentMethodId == 3) {

                        ttq.track('PlaceAnOrder', {
                            contents: orderProducts,
                            content_type: 'product',
                            value: productsTotalValue,
                            currency: LhApp.Context.Currency.Code
                        });
                    } else {

                        ttq.track('CompletePayment', {
                            contents: orderProducts,
                            content_type: 'product',
                            value: productsTotalValue,
                            currency: LhApp.Context.Currency.Code,
                            email: sha256(orderScope.Model.Data.Billing.Email),
                            phone_number: sha256(orderScope.Model.Data.Billing.Mobile)
                        });
                    }
                });

            }
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            var _cartAddResponses = []; // Used for add to cart
            var _wishAddResponses = []; // Used for add to wishlist
            var cartModel; // Saves current cartModel state
            var wishModel; // Saves current wishModel state

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                CanTrack = LhApp.Function.Tracking.canTrack();
                Init();
            });

            //HELPER this script keeps track of products added to wishlist 
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Add, TrackingScriptName + '_add_to_wishlist', function (envelope) {

                if (!envelope.message.data) return;

                var res = envelope.message.data;
                _wishAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty)
                });
            });

            //TRACK add to wishlist (recorded by the ABOVE script) - Push "add_to_wishlist" Event
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, TrackingScriptName + '_add_to_wishlist_success', function (envelope) {

                wishModel = envelope.message.data;

                if (!wishModel || !_wishAddResponses) return;

                var pAddResponse = _wishAddResponses.shift();

                (function AddToWishTrack(p) {
                    if (!p)
                        return;

                    var product = wishModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && (i.VariantId == p.SkuId || p.SkuId === undefined);
                    })[0];

                    if (product) {

                        var productPrice = parseFloat(product.Prices.Price);

                        ttq.track('AddToWishlist', {
                            contents: [
                                {
                                    content_id: product.ProductId,
                                    content_name: product.Title,
                                    content_category: product.Category,
                                    brand: product.Manufacturer,
                                    price: productPrice,
                                }],
                            content_type: 'product',
                            value: productPrice,
                            currency: LhApp.Context.Currency.Code
                        });

                    }

                    AddToWishTrack(_wishAddResponses.shift());

                })(pAddResponse);
            });

            //HELPER this script keep track of products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty)
                });

            });

            //HELPER this script keeps track of products added to cart from wishlist page
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.MoveToCart, TrackingScriptName + '_add_to_cart_from_wishlist', function (envelope) {

                if ((LhApp.Context.Item.Template != "wishlist") || !envelope.message.data) return;

                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.productId,
                    SkuId: res.skuId,
                    listKey: 'Wishlist',
                    index: 0
                });
            });

            //HELPER this script keeps track of "move all to cart" from the wishlist page
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.MoveAllToCart, TrackingScriptName + '_move_all_to_cart_from_wishlist', function (envelope) {

                if ((LhApp.Context.Item.Template != "wishlist") || !envelope.message || (wishModel.Items.length <= 0)) return;

                wishModel.Items.forEach(function (Item, index) {
                    _cartAddResponses.push({
                        ProductId: Item.ProductId,
                        SkuId: Item.VariantId,
                        listKey: 'Wishlist',
                        index: index
                    });
                });

            });

            //TRACK add to cart (recorded by the ABOVE script) - Push "add_to_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName + '_add_to_cart_success', function (envelope) {

                cartModel = envelope.message.data.Cart;

                if (!cartModel || !_cartAddResponses) return;

                var pAddResponse = _cartAddResponses.shift();

                (function AddToCartTrack(p) {
                    if (!p)
                        return;

                    var product = cartModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && (i.VariantId == p.SkuId || p.SkuId === undefined);
                    })[0];

                    if (product) {

                        var productPrice = parseFloat(product.Prices.Price);

                        ttq.track('AddToCart', {
                            contents: [
                                {
                                    content_id: product.ProductId.toString(),
                                    content_category: product.Category,
                                    content_name: product.Title,
                                    brand: product.Manufacturer,
                                    quantity: product.Quantity,
                                    price: productPrice,
                                }],
                            content_type: 'product',
                            value: productPrice * product.Quantity,
                            currency: LhApp.Context.Currency.Code
                        });

                        listToProductMap.items.push({ variantId: product.VariantId, list: p.listKey, index: p.index }); // Save list of product
                        localStorage.setItem('listToProductMap', JSON.stringify(listToProductMap));
                    }

                    AddToCartTrack(_cartAddResponses.shift());

                })(pAddResponse);
            });

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });

            //TRACK product view (changed)
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (!_isUserSelectedProduct)
                    return;

                var model = envelope.message.data.model;

                var productPrice = parseFloat(model.Prices.UnitPrice);

                ttq.track('ViewContent', {
                    contents: [
                        {
                            content_id: model.ProductId,
                            content_name: model.Name,
                            content_category: model.Category,
                            price: productPrice,
                        }],
                    content_type: 'product',
                    currency: LhApp.Context.Currency.Code
                });
            });
        }
    });
})();